import RestService from "./restService";
import { MESSAGE } from "../../url/index";

const singleton = Symbol();
const singletonEnforcer = Symbol();

/**
 *
 */
class MessageService extends RestService {
  constructor(enforcer) {
    super(MESSAGE);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Message RestService more than one");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new MessageService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default MessageService;
